import * as z from "zod";

const schema = z.object({content: z.string()});

const model = schema.transform((values) => ({
	...values
}));

export const SalesManagementModifyModel = {schema, model};
export type ISalesManagementModifyModel = z.infer<typeof SalesManagementModifyModel.model>;
export const DEFAULT_SALES_MANAGEMENT_MODIFY: ISalesManagementModifyModel = {
	content: ""
};
